import React, { useState } from 'react';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href="https://wa.me/12244154202"
      target="_blank"
      rel="noreferrer"
      className="wa-float"
      title="Chat on WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="wa-icon">💬</span>
      {hovered && <span className="wa-label">Chat with us!</span>}
    </a>
  );
};

export default WhatsAppFloat;
